import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { WrapperCircleProps, MapTypes, ProgressListStateType, GenericCircleProps } from './types'

const circleSize = '33px'
const neutralColor = 4

const getBackgroundColor = (state: ProgressListStateType) => {
  const map: MapTypes = {
    complete: 'green',
    warning: 'warning',
    in_progress: 'ultraViolet',
    not_started: 'blank'
  }
  return map?.[state as keyof MapTypes]
}

export const StepProgressBarWrapper = styled(Flex)`
  margin-block: 0;
  margin: 0 32px 64px 0;
  padding-inline: 0;
  min-width: 20vw;
  max-width: 25vw;
`

export const List = styled(Flex)<WrapperCircleProps>`
  margin-top: 10px;
  height: 40px;
  width: 100%;
  max-width: 100%;
  cursor: ${props => props.noClickCursor ? 'default' : 'pointer'};

  h6 {
    display: flex;
    color: ${props => props.state === 'not_started' ? props.theme.colors.shades.neutral[neutralColor as number] : props.theme.colors.main.dark};
  }
`

export const Line = styled.div`
  background-color: ${props => props.theme.colors.shades.neutral[neutralColor as number]};
  width: 1px;
  height: 32px;
  position: absolute;
  left: 50%;
  top: 100%;
`
export const WrapperCircle = styled(Flex)<WrapperCircleProps>`
  position: relative;
  background-color: ${props => props.theme.colors.main[getBackgroundColor(props.state)]};
  border-radius: 50%;
  width: ${circleSize};
  min-width: ${circleSize};
  max-width: ${circleSize};
  height: ${circleSize};
  min-height: ${circleSize};
  max-height: ${circleSize};
  border: 1px solid ${props => props.state === 'not_started'? props.theme.colors.shades.neutral[neutralColor as number] : props.theme.colors.shades.neutral[0]};
  margin: 8px 8px 8px 0;
  color: ${ props => props.state === 'in_progress'? props.theme.colors.main.blank : props.theme.colors.shades.neutral[neutralColor as number]};

  h5 {
    color: ${props => props.state === 'in_progress'? props.theme.colors.main.blank : props.theme.colors.shades.neutral[neutralColor as number]};
  }

  ${props => props.noClickCursor && css`
    cursor: not-allowed;

    & + h6 {
      cursor: not-allowed;
    }
  `} 

  
`
export const GenericCircle = styled('span')<GenericCircleProps>`
  display: inline-block;
  width: ${props => props.circleWidth || '6px'};
  height: ${props => props.circleHeight || '6px'};
  border-radius: ${props => props.circleBorderRadius|| '50%'};;
  background-color: ${props => props.theme.colors.main[props.bgColor || 'ultraViolet']};
  z-index: 10;
  cursor: pointer;

  ${props => props.margin && css`
    margin: ${props.margin};
  `}

  ${props => props.emptyCircle && css `
    width: 4px;
    height: 4px;
    border: 1px ${props => props.theme.colors.main['ultraViolet']} solid;
    background-color: transparent;
  `}
`
